import * as React from "react";
import { forwardRef } from "react";
const SvgInteraction = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 17.065, height: 18.14, viewBox: "0 0 17.065 18.14", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "m12.623 0-.93.95 2.83 2.83H.599v1.323h13.925l-2.83 2.83.93.95 3.966-3.964.475-.475-.475-.475ZM4.442 9.256.475 13.219 0 13.694l.475.475 3.967 3.967.93-.95-2.83-2.83h13.924v-1.319H2.541l2.83-2.83Z", className: "s94cbec34cb2fd727dea197555a8f9cc4__a" }));
const ForwardRef = forwardRef(SvgInteraction);
export { ForwardRef as ReactComponent };
